import { Box, Button, Container, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import FavoriteTwoToneIcon from '@mui/icons-material/FavoriteTwoTone';

// Structural copy of subscribingSuccess.tsx. Deliberately stateless and API-free: the
// browser can reach this page before Stripe's webhook has recorded the contribution
// (webhook delivery lags the redirect), so this page must never assert a recorded
// amount, a lifetime total, or any other webhook-derived fact, and must never render an
// error or "not found" state while that delivery is still in flight.
export const SupportSuccess = () => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Thank You - Portfoliomatic</title>
      </Helmet>
      <Container maxWidth="md" sx={{ textAlign: 'center', py: 8 }}>
        <Box sx={{ mb: 4 }}>
          <FavoriteTwoToneIcon
            sx={{
              fontSize: 80,
              color: 'error.main',
              mb: 2
            }}
          />
          <Typography variant="h2" component="h1" gutterBottom>
            Thank You for Your Support!
          </Typography>
          <Typography variant="h5" color="textSecondary" paragraph>
            Your contribution helps keep Portfoliomatic running. It may take a few
            moments to appear in your Support summary - there's nothing more you need
            to do.
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="large"
          onClick={() => navigate('/settings?tab=support')}
        >
          Back to Support
        </Button>
      </Container>
    </>
  );
};
